import { Injectable } from '@angular/core';
import { AppConfigService } from '../../app-config.service';

const phoneRegexEn: any = [/[1-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
const phoneRegexFr: any = [/[1-9]/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

const phoneMaskEn: any = '000-000-0000';
const phoneMaskFr: any = '000 000-0000';

@Injectable({
  providedIn: 'root'
})
export class PhoneMaskService {
  language: string;

  constructor(private readonly _appConfigService: AppConfigService) {
    this.language = this._appConfigService.configData.contexteEnvironnement.langue;
  }

  getPhoneMask(): Array<any> {
    switch (this.language) {
      case 'fr':
        return phoneMaskFr;
      case 'en':
        return phoneMaskEn;
      default:
        return phoneMaskFr;
    }
  }

  getPhoneRegex(): Array<any> {
    switch (this.language) {
      case 'fr':
        return phoneRegexFr;
      case 'en':
        return phoneRegexEn;
      default:
        return phoneRegexFr;
    }
  }
}
